import "jquery-ui/dist/jquery-ui.min.js";
import "./image-picker.js";
import chroma from "chroma-js";
import ColorScheme from 'color-scheme';
import Color from './colors';
import html2canvas from 'html2canvas';
import { prominent } from 'color.js';

(function () {
    let PaletteScheme;

    PaletteScheme = (function () {
        let typeIsArray, extract, download, display, nohash, apply, setting, sidebar, position, unstack = [], restack = [];

        let $fc = $('#full-container'),
            $pg = $('#palette-generator'),
            $sb = $('.stage-box'),
            $pb = $('.palette-box'),
            $pt = $('.palette-trigger'),
            $vt = $('.variation-trigger'),
            $hp = $('.history-panel'),
            $sp = $('.saved-panel'),
            $cc = $('#contrast-checker'),
            $ap = $('#adjust-palette'),
            $cg = $('.contrast-grid'),
            $pe = $('#palette-export'),
            $ip = $('#image-palette'),
            $cp = $('#community-palette'),
            $cms = $('.community-store'),
            $cmp = $('#community-preview'),
            $ww = $('.workshop-wrap'),
            $wb = $('.workshop-bench'),
            $bm = $('.benchmark'),
            $cl = $('.clone'),
            $ml = $('.master-label'),
            $png = $('.export-png'),
            $tpng = $('#temp-png'),
            $tcol = $('.temp-colors'),
            $reload = $('.reload'),
            $spin = $('.spin > a'),
            $undo = $('.undo'),
            $redo = $('.redo'),
            $share = $('.share'),
            $send = $('.send'),
            $export = $('.export'),
            $adjust = $('.adjust'),
            $save = $('.save'),
            $rs = $('#results'),
            $mpt = $('.master-panel-toggle'),
            $toggle = $('.panel-toggle'),
            $bar = $('.sub-menu-container'),
            $wss = $('.web-safe-switch'),
            $injector = $('.injector'),
            $ss = $('.settings-switch'),
            $picker = $('#single-picker'),
            $preview = $('.color-front'),
            $gp = $('.gradient-pickers'),
            $invert = $('.switch-gradient'),
            $pp = $('.preview-picker'),
            $apply = $('.apply'),
            $sliders = $('.slider'),
            $si = $('.slider-input'),
            $h = $('#hue'),
            $s = $('#saturation'),
            $l = $('#luminosity'),
            $ms = $('#mirror-search'),
            $mi = $('#mirror-input');


        const cm = new bootstrap.Modal($cc);
        const ap = new bootstrap.Modal($ap);
        const em = new bootstrap.Modal($pe);
        const im = new bootstrap.Modal($ip);
        const rs = new bootstrap.Offcanvas($rs);
        const cp = new bootstrap.Modal($cp);

        typeIsArray = Array.isArray || function (value) {
            return {}.toString.call(value) === '[object Array]';
        };

        PaletteScheme.SCHEMES = {
            auto: 'auto',
            mono: 'sequence',
            monochromatic: 'sequence',
            tints: 'sequence',
            shades: 'sequence',
            gradient: 'sequence',
            contrast: 'mode',
            triade: 'mode',
            tetrade: 'mode',
            analogic: 'mode'
        };

        PaletteScheme.VARIATIONS = {
            default: 0,
            pastel: 1,
            soft: 2,
            light: 3,
            hard: 4,
            pale: 5
        };

        PaletteScheme.COLLECTION = [["#705551", "#FA0096", "#F989AF", "#E1C8A0", "#B39E7C"], ["#595758", "#FFEEF2", "#FFE4F3", "#FFC8FB", "#FF92C2"], ["#423E37", "#E3B23C", "#EDEBD7", "#A39594", "#6E675F"], ["#130303", "#2D080A", "#7C3626", "#F5853F", "#FFCDBC"], ["#3C1518", "#69140E", "#A44200", "#D58936", "#F2F3AE"], ["#F75C03", "#D90368", "#820263", "#291720", "#04A777"], ["#FFFFFF", "#ECF2F6", "#0078C8", "#11B5EA", "#FFD91A"], ["#BA467B", "#F4E3C0", "#E55C52", "#641F26", "#F32631"], ["#032560", "#45474E", "#8978FB", "#641838", "#B2098B"], ["#D25254", "#9F072E", "#3B3357", "#71C0E7", "#ECE6EE"], ["#5E1960", "#8B11E1", "#D699A5", "#F00091", "#641865"], ["#0EC13E", "#96E18C", "#537C6D", "#E57E4C", "#B51B5A"], ["#E4ABA0", "#612B4D", "#F7E2F6", "#712000", "#8524DA"], ["#F3C3BE", "#C27CE8", "#CD01C1", "#72436D", "#76A964"], ["#2B2D42", "#8D99AE", "#EDF2F4", "#EF233C", "#D90429"], ["#EEFD9B", "#E2B086", "#E89003", "#DA3E12", "#C52B3A"], ["#B6B3DC", "#502E56", "#37C0FA", "#6C4B9B", "#EE0470"], ["#970D63", "#4B164B", "#681584", "#9611B4", "#EDC4E3"], ["#E3F6B8", "#48A184", "#7ABE2C", "#E96C2E", "#9A2330"], ["#763D0C", "#F76902", "#E9473E", "#C40769", "#225518"], ["#000000", "#16213B", "#FF1779", "#E6E6E6", "#FFFFFF"], ["#1BFA97", "#EDAABA", "#E968D8", "#985EAE", "#245553"], ["#872BBA", "#B70662", "#F8194E", "#13D3FF", "#95A1CE"], ["#F7B1F6", "#E8ECF9", "#670243", "#AB2390", "#AF4E11"], ["#B990C6", "#95075C", "#D35F21", "#2E3228", "#1DA79E"], ["#B91D61", "#E48C5B", "#9F612D", "#29466F", "#B94BB5"], ["#222830", "#3B4049", "#00B55B", "#DDDDDD", "#FFFFFF"], ["#8D1000", "#C64300", "#FF7600", "#FFA839", "#FFDA73"], ["#00608D", "#21BF73", "#B0EACD", "#F9FCFB", "#FD5E53"], ["#F9F9F9", "#E1E5f4", "#C2CAE9", "#939BB8", "#636B87"], ["#1B3C59", "#456173", "#524B46", "#6F5CFF", "#A6ED8E"], ["#FF99DF", "#FF72C3", "#FF4BA7", "#FF248C", "#EF0F72", "#CE0A5A", "#AD0542", "#8D002B"], ["#F8EDE3", "#B3BAC0", "#19334A", "#00182F", "#AD8F5F"], ["#FFFFFF", "#EEF8FD", "#007BFF", "#012C9B", "#000639"], ["#FF00B2", "#FA3288", "#F5635E", "#F09534", "#EBC60A"], ["#FFFFFF", "#E6D8D5", "#CDB0AA", "#9D827C", "#6D544F"], ["#F0EAD2", "#DDE5B4", "#ADC178", "#A98467", "#6C584C"], ["#FB6095", "#FB878E", "#FBAF87", "#FBD680", "#FBFD79"], ["#251D3A", "#2A2550", "#E04D01", "#FF7700"], ["#003F5C", "#58508D", "#8A508F", "#BC5090", "#DE5A79", "#FF6361", "#FF8531", "#FFA600"], ["#57375D", "#FF3FA4", "#FF9B82", "#FFC8C8", "#FBEDED"], ["#413E4A", "#73626E", "#B38184", "#F0B49E", "#F7E4BE"], ["#DAB8FF", "#F7C6F5", "#F6AFFF", "#B5E0FF", "#9DD8FF"], ["#DEB887", "#CD853F", "#D2691E", "#A52A2A", "#8B4513"], ["#5E4F6D", "#8F5572", "#F26B6B", "#F9ADA0", "#FAD02E"], ["#1D3461", "#1F487E", "#247BA0", "#70C1B3", "#B2DBBF"], ["#556270", "#4ECDC4", "#C7F464", "#FF6B6B", "#C44D58"], ["#F9EBB2", "#DAD2BC", "#A3BFA8", "#457B9D", "#1D3557"], ["#0081A7", "#00AFB9", "#FDFCDC", "#FED9B7", "#F07167"], ["#B0CC99", "#677E52", "#3A4F30", "#2F3A24", "#2A322A"], ["#D8E2DC", "#FFE5D9", "#FFCAD4", "#F4ACB7", "#9D8189"], ["#E63946", "#F1FAEE", "#A8DADC", "#457B9D", "#1D3557"], ["#3C6E71", "#84A98C", "#CAD2C5", "#DBE9B7", "#FFD662"], ["#2A363B", "#4A536B", "#8595A1", "#BBC2CF", "#D3D9DF"], ["#FFB997", "#F67E7D", "#843B62", "#4B4E6D", "#4D7A8F"], ["#FFADAD", "#FFD6A5", "#FDFFB6", "#A0E7E5", "#69A1AC"], ["#355C7D", "#6C5B7B", "#C06C84", "#F67280", "#F8B400"], ["#2A363B", "#EF233C", "#D90429", "#457B9D", "#F1FAEE"], ["#264653", "#2A9D8F", "#E9C46A", "#F4A261", "#E76F51"], ["#6A0572", "#AB83A1", "#FDEEA7", "#89ABE3", "#BFDBFE"], ["#9D8189", "#B0CC99", "#677E52", "#3A4F30", "#2F3A24"], ["#8338EC", "#3A86FF", "#96D38C", "#F6416C", "#FFDD95"], ["#F4E1D2", "#E07A5F", "#3D405B", "#81B29A", "#F2CC8F"], ["#FFD6A5", "#F9A875", "#9E2A2B", "#54494D", "#2F2048"], ["#FFA07A", "#FF6F61", "#FF9E2F", "#B22222", "#DC143C"], ["#529BFB", "#E413E6", "#E198D7", "#7710F9", "#3E1E53"], ["#FAC8C8", "#C89696", "#C86496", "#C896C8", "#966464"], ["#DCA5A5", "#DCDCDC", "#DCA5DC", "#A56E6E", "#DCA56E"], ["#F0B4B4", "#B47878", "#F0F0F0", "#F0B478", "#F07878"], ["#D28C8C", "#D2D2D2", "#D28CD2", "#FFD2D2", "#D2468C"], ["#F0F0F0", "#F0F0A0", "#F0F000", "#F0C800", "#282828"], ["#787878", "#505050", "#C8C8C8", "#A0A0A0", "#785050"], ["#1C2129", "#353A42", "#2DBB25", "#EEEEEE"], ["#B8D391", "#079A5E", "#9CD533", "#FF481D", "#84483B"], ["#94FF9E", "#50DA6F", "#0DB43F", "#FFD000"], ["#F3EDE1", "#E91D79", "#922172", "#410422", "#FDE6B5"], ["#86787F", "#5B4E54", "#30242A", "#181215", "#D5511C"], ["#FF805A", "#CB331F", "#823057", "#540069"], ["#AFBF89", "#779D84", "#A59ADA", "#AE76C7"], ["#A4016D", "#FFEEF2", "#FFE4F3", "#FFC8FB", "#FF92C2"], ["#FFFFFF", "#C6ECEB", "#8DD8D7", "#ECADF0", "#E591EB"], ["#093A23", "#3F644A", "#748E70", "#AAB797", "#DFE1BD"], ["#1C2129", "#353A42", "#AA4562", "#EEEEEE"], ["#1C2129", "#353A42", "#FC1AAD", "#EEEEEE", "#8D0051"], ["#CDCCE9", "#7093FF", "#350065"], ["#333333", "#C5D2CA", "#AEFFDE"], ["#C7B6D7", "#88659C", "#4A274F", "#F0A70C", "#CB1D3D"], ["#4522CB", "#6B41F2", "#E9E2FD", "#FFFFFF", "#FCE490"], ["#04C3D9", "#2A0A92", "#E2FDF5", "#FFFFFF", "#FCD036"], ["#FFE0FF", "#E6AEF2", "#CC7CE5", "#9A4DB4", "#FF0582"], ["#E9D89B", "#C026AD", "#462578", "#854ABF", "#C775BA"], ["#150B41", "#450F3A", "#751233", "#A4162C", "#D41925"], ["#A8AF76", "#79814B", "#4B5320", "#262A10", "#FF7C0B"], ["#E9E9E9", "#C8C8A0", "#A0A078", "#C8A078", "#A0B9C8"], ["#FFD699", "#FFB366", "#FF9966", "#FFCC99", "#FFCCCC"], ["#66B2FF", "#66A3FF", "#6694FF", "#6685FF", "#6676FF"], ["#EFD3B5", "#885E8B", "#5F093D", "#B21368", "#D67BA8"], ["#6D7AD0", "#A0A0C8", "#785078", "#DEE583"], ["#E0EDFF", "#7BDEFF", "#394CF8", "#071B4B", "#123D66"], ["#FFFFFF", "#FFF6CB", "#F8D914", "#E2DDD4", "#000000"], ["#F9F9F7", "#4C90EE", "#1A2E44", "#1F5263", "#24D172"], ["#F6C234", "#F38108", "#15487C", "#28A254", "#0D7547"], ["#FF9CFF", "#FF54E1", "#FF0DC3", "#192184", "#000055"], ["#8578FC", "#3E2461", "#795786", "#9B81A4", "#CB2D94"], ["#FFFFFF", "#E6D6CE", "#F2153B", "#312C53", "#B6A180"], ["#563C5E", "#925D62", "#EDA97E", "#DC0E3F", "#84132C"], ["#32CBE4", "#A427B6", "#36217A", "#9B70F1", "#3000CB"], ["#005050", "#002828", "#002850", "#F0C878", "#F0A050"], ["#CEC4A7", "#ECE6D6", "#6B6445", "#87816E", "#707E57"], ["#F0F0F0", "#282828", "#505050", "#C8C8C8", "#505028"], ["#280000", "#282828", "#000000", "#500000", "#502828"], ["#C8F0F0", "#C8C8F0", "#A0C8F0", "#0078C8", "#F0F0F0"], ["#EED7E3", "#A078A0", "#785078", "#502850", "#292E4D"], ["#FF247D", "#F8B1E2", "#FFF4FF", "#0F172A", "#D1FF19"], ["#242A39", "#000000", "#FEFD62", "#989682", "#FFFFFF"], ["#E3FFE8", "#00ECAC", "#002725", "#021B1B", "#ED7F5D"], ["#EFE2D7", "#DCD1C3", "#D9C1B1", "#7A6E7F", "#645868"], ["#FDF0D1", "#A77883", "#603641", "#4A222D", "#340F1A"], ["#F1A900", "#8C78A7", "#4B4285", "#702647", "#95090A"], ["#DF5441", "#C33B2C", "#363636", "#AAB797", "#DFE1BD"], ["#FFFFFF", "#CFB2D4", "#331C3E", "#EE5927", "#8073C3"], ["#003863", "#005394", "#159AB7", "#1B4A60", "#00364B"], ["#F817B4", "#DC45B5", "#C073B6", "#A4A0B6", "#88CEB7"], ["#FFFFFF", "#DEE6FE", "#BCCDFE", "#9BB3FD", "#799AFC"], ["#852E18", "#FCE490", "#FFC651", "#C99729", "#936800"], ["#A88642", "#905F2F", "#523831", "#D9D568", "#F1FC7B"], ["#FFFFFF", "#DCD4CC", "#B8A998", "#A5D595", "#87C771"], ["#B52B86", "#C46082", "#C49E77", "#CBD77C", "#EAF4AC"], ["#F7FF90", "#BFFF4E", "#2FB494", "#23D79A", "#17FAA0"], ["#EEE9E3", "#E7D8C9", "#BD8F6E", "#87816E", "#241F19"], ["#F9F9F9", "#DBE0EF", "#F6CFF0", "#561051", "#080A43"], ["#E8D1FF", "#BEACEB", "#8B8BE6", "#3D7BAB", "#2A5C7C"], ["#D9E3DD", "#FFE6DA", "#FFCCD5", "#F4AEB8", "#9E828A"], ["#D81878", "#1690A8", "#FFC0D8", "#FFE9E9", "#FFFFFF"], ["#000000", "#A0A0A0", "#787878", "#505050", "#007850"], ["#006C4A", "#B0CC99", "#DB4A14", "#3A4F30", "#2F3A24"], ["#56637B", "#ECD5BB", "#840921", "#FFFFFF", "#0D2A45"], ["#A897CF", "#7F27FF", "#FFCC5A", "#FF9F2C", "#FE8811"], ["#FFFFFF", "#144467", "#84B6CA", "#4792B0", "#096D95"], ["#E3FFE8", "#00ECAC", "#002725", "#E3371F", "#FFDA73"], ["#F4C0E0", "#CEBDE0", "#A8BAE1", "#81B7E1", "#5BB4E1"], ["#614BC3", "#8763F1", "#33BBC5", "#85E6C5", "#C8FFE0"], ["#221680", "#0A6CB5", "#2CB2B7", "#D2F1AA", "#F4F4F4"], ["#F2EEE7", "#FED633", "#FF8502", "#562511", "#32160A"], ["#000639", "#E5111E", "#F9C4C7", "#F2888F", "#EC4D56"], ["#FFFFFF", "#484848", "#D5FEC4", "#82FB4D", "#58FA12"], ["#FFFFFF", "#FFDDFA", "#B8D45D", "#EDF4D7", "#DCEAAE"], ["#FFFFFF", "#FF98E9", "#BBB3FC", "#988DFB", "#7667F9"], ["#FFFFFF", "#CDC9D3", "#9B93A7", "#695D7A", "#A25772"], ["#0F011E", "#00A4FF", "#FFFFFF", "#FF0069", "#FF60A0"], ["#43766C", "#E1DDB9", "#C5AF94", "#B19470", "#854F44"], ["#212121", "#262626", "#FF6D37", "#A6A6A6", "#FFFFFF"], ["#17BAEF", "#0078C8", "#3E5367", "#2E4052", "#EAF3F9", "#69EFBF"], ["#1C2830", "#DAFBEF", "#00AA64", "#8FF3CF", "#69EFBF"], ["#FEDAEB", "#FDB4D7", "#FB8FC3", "#FA69AF", "#00817A"], ["#6EE2C1", "#77B7B7", "#818CAC", "#8A60A2", "#933597"], ["#ACCE87", "#B4A8A2", "#BD82BC", "#C51A50", "#E40550"], ["#FF8B65", "#F14837", "#E20509", "#A90305", "#710000"], ["#000000", "#DFDFDF", "#FFCA00", "#AFAFAF", "#7E7E7E"], ["#BAFFFF", "#81EEDC", "#6F045C", "#26003B", "#FDBDFF"], ["#F1F5F2", "#D9EBDC", "#045E6A", "#DA1D79", "#BE0063"], ["#BFBFBF", "#D2D2D2", "#F2EFE5", "#E3E1D9", "#D2CEC3"], ["#643030", "#8B5B43", "#B28657", "#D8B16A", "#FFDC7D"], ["#FFF4EC", "#F6E1D1", "#F1BD95", "#CE5A67", "#2D2222"], ["#FBF5E7", "#F9E2AF", "#49CCDC", "#1EB2CA", "#009FBD"], ["#B53465", "#A1A7B5", "#727B8F", "#434F6A", "#2E3A54"], ["#4E4031", "#6A635E", "#87868B", "#A3A8B7", "#BFCBE4"], ["#C8C8C8", "#63566A", "#238282", "#AFD6D6", "#C8F0F0"], ["#644A6A", "#FFF9ED", "#FCEED1", "#F9DDA3", "#FFC978"], ["#FFF7CF", "#F1DB9D", "#969867", "#1A5C3F", "#00462B"], ["#927EAE", "#F197C2", "#FFD4F5", "#FFE5F8", "#171B2C"], ["#FFFFFF", "#E5E5E5", "#D3D3D3", "#393939", "#EF0836"], ["#00ED64", "#106149", "#42494F", "#C8C8C8", "#EAEAEA"], ["#825B43", "#FF7139", "#015672", "#00415C", "#002D47"], ["#FFFFFF", "#DCD4CC", "#605547", "#08FFC9", "#A3FFE7"], ["#FFFFFF", "#8AC8F5", "#01094E", "#0A214B", "#F4DC35"], ["#EDF6EE", "#D1C089", "#B3204D", "#412E28", "#151101"], ["#714B34", "#E08E79", "#F1D4AF", "#ECE5CE", "#B5E3E0"], ["#382F32", "#FFEAF2", "#FCD9E5", "#FBC5D8", "#E8396A"], ["#F27435", "#3B2D38", "#3E5367", "#2E4052", "#1A2C3D"], ["#FF186B", "#033233", "#D9CFBE", "#C6B69D", "#B39E7C"], ["#CAFFBF", "#95FF80", "#EB0052", "#A4003A", "#890027"], ["#FFE1BF", "#FFC380", "#ED004B", "#A60035", "#FF2C00"], ["#5C0099", "#40006B", "#E6BFFF", "#CC80FF", "#BF009A"], ["#30BFB6", "#E69E73", "#BF6530", "#805840", "#68432C"], ["#FFEEBF", "#FFDD80", "#FFBB00", "#00A682", "#00745B"], ["#0066B3", "#00487D", "#BFE4FF", "#80C9FF", "#FF5500"], ["#FFD7BF", "#FFE6E8", "#FFBFC6", "#FF808D", "#BF606A"], ["#340099", "#24006B", "#D5BFFF", "#AB80FF", "#FFCE00"], ["#FFFFFF", "#FFE1BF", "#FF2C00", "#000000", "#484143"], ["#F6F9FC", "#BF2436", "#57D2D2", "#223344", "#0E2030"], ["#6A6FBF", "#E8EAFF", "#8D94FF", "#737DE5", "#5967CB"], ["#FFF2FF", "#FFD8FF", "#EABFFF", "#6A6FBF", "#61C4BE"], ["#EDE2DC", "#BDAAB4", "#80737A", "#695D64", "#8DB28C"], ["#90E3A2", "#F9F8F8", "#FF0E47", "#E10033", "#C40020"], ["#F6F9FC", "#7A879E", "#6D544F", "#002E47", "#48AAD4"], ["#656565", "#333333", "#262626", "#80B442", "#53A153"], ["#322D27", "#68493B", "#A65F47", "#E06549", "#EF7154", "#F79176", "#F9C0AC"], ["#F0F0F0", "#C8C8C8", "#2850F0", "#2850C8", "#2828A0"], ["#58506E", "#775590", "#F36CE7", "#FAA1E5", "#FA2E47"], ["#F0F0F0", "#F0F0C8", "#F0F0A0", "#C8F0A0", "#C8C8A0"]];

        function PaletteScheme() {
            this.col = [];
            this._scheme = 'auto';
            this._variation = 'default';
            this._websafe = false;
            this._length = 5;
            this._base = chroma.random().hex();
            this._base_end = chroma.random().hex();
            this._history = [];

            this.COLOR = new Color();

            // TODO: Place in load and change parse tags to explicit
            window.__gcse || (window.__gcse = {});
            window.__gcse.searchCallbacks = {
                parsetags: 'explicit', // or 'onload'
                image: {
                    ready: this.gready.bind(this),
                },
            };

            // Dynamically load the GCSE script
            const s = document.createElement('script');
            s.src = 'https://cse.google.com/cse.js?cx=d00458aed6d2f4319';
            s.async = true;
            document.head.appendChild(s);

            console.log("🚀 ~ PaletteScheme ~ window.__gcse:", window.__gcse);
            console.log("🚀 ~ PaletteScheme ~ window.__gcse.searchCallbacks:", window.__gcse.searchCallbacks);

            this.load().reset(this._length).init().config().render();
        }

        PaletteScheme.prototype.init = function () {
            $(document).on('keydown', (e) => {
                if (e.target.nodeName !== 'INPUT') {
                    let k = [32, 89, 90];

                    if (k.includes(e.which)) {
                        e.preventDefault();
                        switch (e.which) {
                            case 32: // SPACEBAR
                                return this.reload();
                            case 89: // Y
                                return this.redo();
                            case 90: // Z
                                return this.undo();
                            default:
                        }
                    }
                }
            });

            // SUB MENU
            $toggle.on('click', function (e) {
                return sidebar($(this));
            });

            $pt.add($vt).on('click', (e) => {
                return this.set($(e.currentTarget));
            });

            $spin.on('click', (e) => {
                return this.spin($(e.currentTarget));
            });

            $reload.on('click', (e) => {
                return this.reload();
            });

            $invert.on('click', (e) => {
                return this.invert();
            });

            $undo.on('click', (e) => {
                return this.undo();
            });

            $redo.on('click', (e) => {
                return this.redo();
            });

            $send.on('click', (e) => {
                return this.send();
            });

            $cms.on('click', (e) => {
                return this.community();
            });

            $share.on('click', (e) => {
                return this.share();
            });

            $export.on('click', (e) => {
                return this.export();
            });

            $png.on('click', (e) => {
                return this.png();
            });

            $save.on('click', (e) => {
                return this.save();
            });

            $(document).on('click', '.palette-item', (e) => {
                return this.override($(e.currentTarget).children());
            });

            $injector.on('click', (e) => {
                return this.override($('.image-palette .color-chip').children());
            });

            $sliders.on('input', (e) => {
                return this.adjust($(e.currentTarget));
            });

            $si.on('input change', (e) => {
                return this.slide($(e.currentTarget));
            });

            $apply.on('click', (e) => {
                ap.hide();
                return this.override($cl.children());
            });

            $adjust.on('click', (e) => {
                return this.workshop();
            });

            $ms.on('submit', (e) => {
                e.preventDefault();
                return this.mirror();
            });

            $wss.on('change', (e) => {
                this._websafe = !this._websafe;
            });

            $ss.on('change', (e) => {
                return this.setlocal($(e.currentTarget));
            });

            // CONTROLS
            $(document).on('click', '.delete', (e) => {
                return this.delete($(e.currentTarget).closest('.color'));
            });

            $(document).on('click', '.panel', (e) => {
                return this.panel($(e.currentTarget).closest('.color'));
            });

            $(document).on('click', '.shelf', (e) => {
                return this.shelf($(e.currentTarget));
            });

            $(document).on('click', '.contrast', (e) => {
                return this.contrast();
            });

            $(document).on('click', '.info', (e) => {
                return this.open($(e.currentTarget).closest('.color'));
            });

            $(document).on('click', '.mono', (e) => {
                return this.mono($(e.currentTarget).closest('.color'));
            });

            $(document).on('click', '.copy', (e) => {
                return this.copy($(e.currentTarget).closest('.color').find('.code'));
            });

            $(document).on('click', '.lock', (e) => {
                return this.lock($(e.currentTarget));
            });

            $(document).on('click', '.picker', (e) => {
                return this.picker($(e.currentTarget));
            });

            // FUNCTIONS
            $bar.one('mouseenter', function () {
                $(this).removeClass('init');
            });

            $(document).on("fullscreenchange", function () {
                if (!document.fullscreenElement) {
                    $fc.toggleClass('focus-mode');
                }
            });

            return this;
        };

        PaletteScheme.prototype.load = function () {
            let url = window.location.href,
                pathToCheck = window.location.origin + '/generate/',
                pathIndex = url.indexOf(pathToCheck);

            if (pathIndex !== -1 && url.length > pathIndex + pathToCheck.length) {
                let parameterString = url.substring(pathIndex + pathToCheck.length),
                    palette = parameterString.split('-');

                let allValidHexCodes = palette.every(function (value) {
                    return chroma.valid('#' + value);
                });

                if (allValidHexCodes) {
                    palette = palette.map(function (value) {
                        return '#' + value;
                    });

                    this._length = palette.length;
                    this.col = palette;

                } else {
                    pushNotification('All URL paramters must be valid hex values.', 'error');
                }
            } else {
                this.colors();
            }

            return this;
        }

        PaletteScheme.prototype.gready = async function (name, q, promos, results, resultsDiv) { 

            if (results) {
                console.log('results', true);
                rs.show();

                const spinner = $('<div class="spinner mt-5"></div>');

                resultsDiv.append(spinner[0]);

                const row = $('<div>').addClass('row mt-4');
                const fragment = $(document.createDocumentFragment());

                const chips = (colors) => {
                    const palette = $('<div class="color-chips-box palette-item static"></div>');

                    colors.forEach((color) => {
                        palette.append($('<div class="color-chip"><div class="color-chip-bg"></div></div>').css('background-color', color));
                    });

                    return palette;
                };

                for (const result of results) {
                    const col = $('<div>').addClass('col-md-4');
                    const res = $(`
                        <div class="d-flex mt-3 mb-5">
                            <img src="${result.thumbnailImage.url}" class="img-circle" />
                            <div class="ms-3">
                                <div class="result-title">${result.title}</div>
                                <div class="result-source"><a href="${result.contextUrl}" class="external" target="_blank" rel="noreferrer">Source</a></div>
                            </div>
                        </div>
                    `);

                    try {
                        const colors = await prominent(result.thumbnailImage.url, { amount: 5, sample: 30, group: 40 });

                        col.append(chips(colors));
                        col.append(res);
                        fragment.append(col);
                    } catch (error) {
                        console.error('Error fetching colors:', error);
                    }
                }

                row.append(fragment);

                spinner.hide();

                resultsDiv.append(row[0]);
            }

            return this;
        };

        PaletteScheme.presets = function (_base, _base_end) {
            return {
                tints: ['white', _base],
                shades: ['black', _base],
                mono: [chroma(_base).brighten(2).hex(), _base, chroma(_base).darken(2).hex()],
                gradient: [_base, _base_end]
            };
        };

        PaletteScheme.prototype.colors = function () {
            let dispatch, colors,
                scheme = PaletteScheme.SCHEMES[this._scheme];

            dispatch = {
                auto: (function (_this) {
                    return function () {
                        return _this.fromcollection();
                    };
                })(this),
                sequence: (function (_this) {
                    return function () {
                        return _this.sequence();
                    };
                })(this),
                mode: (function (_this) {
                    return function () {
                        return _this.mode();
                    };
                })(this)
            };
            dispatch['monochromatic'] = dispatch['mono'];

            if (scheme != null) {
                colors = dispatch[scheme]();
            } else {
                throw "Unknown color scheme name: " + this._scheme;
            }

            this.col = colors;

            return this;
        };

        PaletteScheme.prototype.scheme = function (name) {
            if (name == null) {
                return this._scheme;
            } else {
                if (PaletteScheme.SCHEMES[name] == null) {
                    throw "'" + name + "' isn't a valid scheme name";
                }
                this._scheme = name;
                return this;
            }
        };

        PaletteScheme.prototype.fromcollection = function () {
            const len = PaletteScheme.COLLECTION.length;
            const random = Math.floor(Math.random() * len);

            return PaletteScheme.COLLECTION[random];
        };

        PaletteScheme.prototype.sequence = function (b, s, l, e) {

            b = b || this._base;
            s = s || this._scheme;
            l = l || this._length;
            e = e || this._base_end;

            let presets = PaletteScheme.presets(b, e);

            return chroma.scale(presets[s]).colors(l);
        };

        PaletteScheme.prototype.mode = function () {
            let scheme = new ColorScheme,
                distance = (Math.random()).toFixed(2);

            scheme.from_hex(nohash(this._base))
                .scheme(this._scheme)
                .variation(this._variation)
                .distance(distance)
                .web_safe(this._websafe);

            return scheme.colors().map(value => '#' + value);
        };

        PaletteScheme.prototype.render = function () {
            let diff, m;
            let len = this._length,
                col = this.col;

            if (len > col.length) {
                diff = Math.abs(len - col.length);

                for (m = 1; m < diff + 1; m++) {
                    const toggle = m % 2 === 0;
                    const n = toggle ? 0 : col.length - 1;
                    const c = Color.shade(col[n], toggle);

                    toggle ? col.unshift(c) : col.push(c);
                }
            } else if (col.length > len) {
                this.col = col.slice(0, len);
            }

            $('.color').each(function (m) {
                if ($(this).hasClass('locked') && !$(this).hasClass('dragging')) {
                    return;
                }

                const h = col[m];

                $(this)
                    .css('background-color', h)
                    .attr('data-color', h)
                    .find('.code').text(nohash(h))
                    .next('.name').text('~' + Color.name(h));

                $(this)
                    .children('div:not(.inner-shades)')
                    .contrast('text', h);

                $(this)
                    .find('.code, .controls > div')
                    .contrast('background', h);
            });

            this.initcontrols().commit();

            return this;
        };

        PaletteScheme.prototype.mock = function (obj) {
            let col = this.col;

            obj = obj || $('.color');

            obj.each(function (m) {
                if ($(this).hasClass('locked')) {
                    return;
                }
                const h = col[m];

                $(this)
                    .css('background-color', h)
                    .attr('data-color', h);
            });

            return this;
        };

        PaletteScheme.prototype.commit = function () {
            if (JSON.stringify(this.col) !== JSON.stringify(this._history[0])) {
                this._history.unshift(this.col.slice());
                this._length = this.col.length;

                this.setstack().spin().url().preview().clone();
            }

            return this;
        };

        PaletteScheme.prototype.url = function () {
            let current = window.location.origin + '/generate/';
            let params = this.col.map(function (param) {
                return param.replace(/^#/, '').toUpperCase();
            });

            params = params.join('-');

            let url = current + params;

            window.history.replaceState({ path: url }, '', url);

            return this;
        };

        PaletteScheme.prototype.initcontrols = function () {
            // HACK: This inits sub-menu tooltips every time this is called, it shouldn't.
            const elements = $('[data-bs-toggle="tooltip"], [data-bs-toggle="modal"]');

            elements.each(function () {
                const type = $(this).data('bs-toggle');

                if (type === 'tooltip') {
                    let tooltip = bootstrap.Tooltip.getInstance(this);

                    if (tooltip) {
                        tooltip.dispose();
                    }
                    new bootstrap.Tooltip(this, {
                        delay: { show: 400, hide: 0 },
                        trigger: 'hover',
                        html: true,
                    });
                } else if (type === 'modal') {
                    if (im) {
                        im.hide();
                    }
                }
            });

            $pb.sortable({
                items: '.color',
                tolerance: 'pointer',
                axis: 'x',
                handle: '.drag',
                containment: 'parent',
                update: (event, ui) => {
                    this.col = extract($pb.children());
                    this.commit();
                }
            });

            $('.color').draggable({
                revert: 'invalid',
                handle: '.drag',
                stack: '.color',
                containment: '.colors',
                connectToSortable: '.colors'
            });

            return this;
        };

        PaletteScheme.prototype.reload = function (c, e) {
            this._base = c || chroma.random().hex();
            this._base_end = e || chroma.random().hex();

            return this.colors().render();
        };

        PaletteScheme.prototype.set = function (obj) {
            const scheme = obj?.attr('palette-type');
            const variation = obj?.attr('palette-variation');

            if (!scheme && !variation) {
                throw new Error('Scheme or variation is undefined.');
            } else {
                let label = scheme ? scheme : variation,
                    type;

                const $label = obj.parents('.dropdown').find('.dropdown-label');
                const $variation = $('.variation-selection');
                const $scheme = $('.scheme-selection');

                if (scheme) {
                    let id = Object.keys(PaletteScheme.SCHEMES).indexOf(scheme);

                    this._scheme = scheme;

                    if (id !== -1 && Object.entries(PaletteScheme.SCHEMES)[id][0] === scheme) {
                        localStorage.setItem('scheme', id);
                    }
                } else if (variation) {
                    this._variation = variation;
                    localStorage.setItem('variation', PaletteScheme.VARIATIONS[variation]);
                }

                if (PaletteScheme.SCHEMES[scheme] === 'sequence') {
                    this.scheme(scheme).colors().render();
                } else {
                    this.reload();
                }

                if (PaletteScheme.SCHEMES[scheme] === 'mode' || variation) {
                    $variation.removeClass('disabled');
                    type = this._scheme + ' + ' + this._variation;
                } else {
                    $variation.addClass('disabled');
                    $scheme.children('.dropdown-label').text('Select scheme');
                    label = label == 'mono' ? 'monochrome' : label;
                    type = label;
                }

                $label.text(label);
                $ml.text(type);
            }

            return this;
        };

        PaletteScheme.prototype.preview = function (p, h) {
            const scheme = PaletteScheme.SCHEMES[this._scheme];
            const isGradient = this._scheme === 'gradient';

            p = p || $preview;
            h = h || this._base;

            if (scheme === 'sequence') {
                $gp.toggle(isGradient);
                $pp.toggle(!isGradient);

                p.css('background-color', h);

                if (isGradient) {
                    $("[gradient-index='1']").css('background-color', this._base_end);
                }
            } else {
                $gp.hide();
                $pp.hide();
            }

            return this;
        }

        PaletteScheme.prototype.spin = function (sel) {
            let input = $('.pl-ns-value');

            if (sel !== undefined) {
                let dir = sel.data('dir');

                if ((dir === 'up' && this._length < 16) || (dir === 'dwn' && this._length > 1)) {
                    if (dir == 'up') {
                        if (PaletteScheme.SCHEMES[this._scheme] !== 'sequence') {
                            this.col = extract($pb.children());
                        }
                        $pb.append(item());
                    } else {
                        $pb.children().last().remove();
                    }
                    this._length += (dir == 'up') ? 1 : -1;

                    PaletteScheme.SCHEMES[this._scheme] === 'sequence' ? this.colors().render() : this.render();

                } else {
                    pushNotification('Size limit hit.', 'error')
                }
            }

            input.val(this._length);

            return this;
        };

        PaletteScheme.prototype.invert = function () {
            let temp = this._base;

            this.col = this.col.slice().reverse();

            this._base = this._base_end;
            this._base_end = temp;

            this.render();

            return this;
        };

        PaletteScheme.prototype.undo = function () {
            if (unstack.length - 2 < 0) {
                return false;
            }

            let pluck = unstack.shift();

            this.col = unstack.splice(0, 1)[0];
            restack.unshift(pluck.slice());

            this.reset(this.col.length).render();

            return this;
        };

        PaletteScheme.prototype.redo = function () {
            if (restack.length === 0) {
                return false;
            }

            let pluck = restack.shift();

            this.col = pluck;
            this.reset(this.col.length).render();

            return this;
        }

        PaletteScheme.prototype.setstack = function () {
            unstack.unshift(this.col.slice());

            $undo.toggleClass('disable-item', unstack.length <= 1);
            $redo.toggleClass('disable-item', restack.length == 0);

            return this;
        }

        PaletteScheme.prototype.reset = function (x) {
            if (x == null) {
                throw "Number of colors is null";
            } else {
                let m;

                $pb.empty();

                for (m = 0; m < x; m++) {
                    $pb.append(item(m));
                }

                this._length = x;
            }
            return this;
        }

        PaletteScheme.prototype.override = function (p) {

            p = p || $pb.children();

            if (p == null || (!typeIsArray(p) && typeof p !== 'object')) {
                throw "Override needs an object or array";
            }

            this.col = typeof p === 'object' ? extract(p) : p;
            this._length = this.col.length;

            this.reset(this._length).render();

            return this;
        }

        PaletteScheme.prototype.clone = function (obj) {

            var compact = $('<div class="color-chips-box palette-item compact"></div>');

            (obj ? obj : $hp).prepend(compact);

            $.each(this.col, (m, color) => {
                compact
                    .append($('<div class="color-chip"><div class="color-chip-bg"></div></div>')
                        .css('background-color', color));
            });

            return compact;
        }

        PaletteScheme.prototype.adjust = function (obj) {
            const $col = $('.clone .color-sample');
            const type = obj.attr('id') || '';
            const $input = type ? $(`[slider-connect="${type}"]`) : $();

            const h = parseFloat($h.val());
            const s = parseFloat($s.val()) / 100;
            const l = parseFloat($l.val()) / 100;

            $col.each(function () {
                const init = $(this).attr('data-color');
                let [hue, saturation, luminosity] = chroma(init).hsl();

                hue = (hue + h + 360) % 360;
                saturation = Math.min(1, Math.max(0, saturation + s));
                luminosity = Math.min(1, Math.max(0, luminosity + l));

                $(this).css('background-color', chroma.hsl(hue, saturation, luminosity).hex());
            });

            if ($input.length) {
                $input.val(obj.val());
            }

            return this;
        };

        PaletteScheme.prototype.slide = function (obj) {

            const connect = obj.attr('slider-connect');
            const val = parseInt(obj.val());

            if (Number.isInteger(Number(val))) {
                $(`#${connect}`).val(val).trigger('input');
            }

            return this;
        }

        PaletteScheme.prototype.delete = function (obj) {
            if ($('.color').length == 1) {
                pushNotification('At least one color is needed.', 'error')
                return false;
            }

            this.col.splice(obj.index(), 1);
            obj.remove();

            this.commit();

            return this;
        }

        PaletteScheme.prototype.panel = function (obj) {
            $bar.hide();

            const n = 20;
            const colors = this.sequence(obj.css('background-color'), 'mono', n);
            const $panel = obj.children('.inner-panel');

            $panel.empty().append(
                Array.from({ length: n }, (_, m) => shelf().css('background-color', colors[m]))
            ).show();

            return this;
        }

        PaletteScheme.prototype.shelf = function (obj) {
            const c = chroma(obj.css('background-color')).hex();
            const m = obj.closest('.color').index();

            this.col[m] = c;
            this.reset(this._length).render();

            $bar.show();

            return this;
        }

        PaletteScheme.prototype.open = function (obj) {
            let h = extract(obj);
            window.open().location.href = '/color/' + nohash(h[0]);

            return this;
        }

        PaletteScheme.prototype.mono = function (obj) {
            this._base = obj.css('background-color');
            this.col = this.sequence(this._base, 'mono');

            this.render();

            return this;
        }

        PaletteScheme.prototype.copy = function (obj) {
            obj.copyToClipboard();

            return this;
        }

        PaletteScheme.prototype.send = function () {

            this.clone($cmp.empty());
            cp.show();

            return this;
        }

        PaletteScheme.prototype.community = function () {

            let col = this.col;

            $.ajax({
                type: 'POST',
                url: sendUrl,
                dataType: 'json',
                data: {
                    colors: col,
                    _token: csrfToken,
                },
                success: (response) => {

                    pushNotification('Palette sent successfully. Thanks for contributing!', 'success');

                    cp.hide();

                },
                error: (xhr, status, error) => {
             
                    pushNotification("Palette couldn't be sent.", 'error');
                    
                }
            });

            return this;
        }

        PaletteScheme.prototype.share = function (obj) {
            copyUrl();

            return this;
        }

        PaletteScheme.prototype.export = function (obj) {
            const formats = ['json', 'array', 'csv', 'css', 'scss'];
            let json = {}, array = [], csv = '', css = '', scss = '';

            $pe.one('shown.bs.modal', () => {
                let col = this.col.map(h => h.toUpperCase());
                const string = (col, prefix) => col.map((h, m) => `<span class="text-lowercase">${prefix}${Color.name(col[m]).replace(/(\(|\))/g, '-').replace(/ /g, '-').replace("'s", '')}</span>: ${h};<br/>`).join('\n');
                const dispatch = {
                    json: () => col.forEach((value, index) => json[Color.name(value)] = value),
                    array: () => array = col.slice(),
                    csv: () => csv = col.join(', '),
                    css: () => css = string(col, '--'),
                    scss: () => scss = string(col, '$'),
                };

                formats.forEach(v => dispatch[v]());
                formats.forEach(format => {
                    const val = (format === 'json' || format === 'array') ?
                        JSON.stringify(format === 'json' ? json : array, null, 2) :
                        format === 'csv' ? csv :
                            format === 'css' ? css :
                                format === 'scss' ? scss :
                                    '';

                    $(`#${format}-format`).html(`<div><code>${val}</code></div>`);
                });
            });

            em.show();

            return this;
        };

        PaletteScheme.prototype.png = function () {
            $tpng.show();
            download(this.col)
                .then(() => html2canvas($tpng[0]))
                .then(canvas => {
                    display(canvas);
                    pushNotification('Image exported!', 'success');
                })
                .catch(error => {
                    console.error('Error during html2canvas conversion:', error);
                    pushNotification('Error exporting image', 'error');
                })
                .finally(() => {
                    $tcol.empty();
                    $tpng.hide();
                });

            return this;
        };

        PaletteScheme.prototype.save = function () {
            let col = this.col;

            $.ajax({
                type: 'POST',
                url: routeUrl,
                dataType: 'json',
                data: {
                    colors: col,
                    _token: csrfToken,
                },
                success: (response) => {
                    this.clone($sp).after(label());

                    pushNotification('Palette saved successfully.', 'success');
                },
                error: (xhr, status, error) => {
                    if (xhr.status == 401 || error == 'Unauthorized') {
                        window.location.href = '/login';
                    } else {
                        pushNotification("Palette couldn't be saved.", 'error');
                    }
                }
            });

            return this;
        };

        PaletteScheme.prototype.contrast = function (obj) {
            const modal = $('.modal-body');
            const colors = this.col.slice();

            colors.push("#ffffff", "#000000");
            $cg.empty();

            $cc.one('shown.bs.modal', (e) => {

                const gw = modal.width();
                const gh = modal.height();
                let n = Math.floor(this._length + 2);
                let bg, text, index = 0, r = 0;

                for (let m = 0; m < Math.floor((n * n)); m++) {
                    if (r === n) {
                        r = 0;
                    }
                    text = colors[r];

                    if (m < n || m < index) {
                        bg = colors[index];
                    } else {
                        bg = colors[index];
                    }
                    if ((m + 1) % n === 0) {
                        index += 1;
                    }
                    r++;

                    let cell = $('<div><span>Aa</span></div>').css({
                        'width': Math.floor(gw / (this._length + 2)) + 'px',
                        'height': Math.floor(gh / (this._length + 2)) + 'px',
                        'background-color': bg,
                        'color': text
                    });

                    $cg.append(cell);
                }
            });

            cm.show();

            return this;
        }

        PaletteScheme.prototype.workshop = function (obj) {
            $ww.hide();
            $wb.children().empty();

            $ap.one('shown.bs.modal', (e) => {
                $.each(this.col, function (m, c) {
                    let $sample = sample(m)
                        .css('background-color', c)
                        .attr('data-color', c)
                        .append(`<div class="code">${nohash(c)}</div>`);

                    $sample.contrast('text', c);

                    $bm.append($sample);
                });

                $bm.children().clone().appendTo($cl);

                $ww.show();
            });

            ap.show();

            return this;
        }

        PaletteScheme.prototype.mirror = function (obj) {
            rs.show();

            const search = google.search.cse.element.getElement('palettesearch');

            search.execute($mi.val());

            return this;
        }

        PaletteScheme.prototype.lock = function (obj) {
            const isOpen = obj.children().hasClass('lock-open');
            const svg = isOpen
                ? '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-lock lock-closed"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>'
                : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-unlock lock-open"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path></svg>';

            obj.html(svg)
                .css('visibility', isOpen ? 'visible' : '')
                .closest('.color')
                .toggleClass('locked');

            return this;
        }

        PaletteScheme.prototype.setlocal = function (obj) {
            let setting = obj.data('settings'),
                val = obj.prop('checked'),
                storage = JSON.parse(localStorage.getItem('settings')) || {};

            storage[setting] = val;

            localStorage.setItem('settings', JSON.stringify(storage));

            apply(setting);

            return this;
        }

        PaletteScheme.prototype.config = function () {
            let settings = JSON.parse(localStorage.getItem('settings')) || {};
            // let scheme = localStorage.getItem('scheme') || false;
            // let k = Object.keys(PaletteScheme.SCHEMES);

            $.each(settings, function (key, val) {
                $('[data-settings="' + key + '"]').prop('checked', val);
            });
            // if (scheme) {
            //     this.set($('[palette-type=' + k[scheme] + ']'));
            // }
            apply(settings);

            return this;
        }

        PaletteScheme.prototype.picker = function (obj) {
            const $color = obj.closest('.color') || {};
            console.log("🚀 ~ PaletteScheme ~ $color:", $color);

            const t = obj.attr('trigger-type');
            const m = obj.attr('gradient-index');

            let c = t === 'gradient' && m == 1 ? this._base_end : $color.css('background-color') || this._base;

            if ($picker.spectrum('get')) {
                $picker.spectrum('destroy');
            }

            $picker.spectrum({
                containerClassName: 'basic-inspector color-inspector-box',
                preferredFormat: 'hex',
                color: chroma(c).hex(),
                showButtons: false,
                showInput: true,
                initInput: true,
                showAlpha: false,
                flat: false,
                move: (h) => {
                    h = h.toHexString();
                    $color?.addClass('dragging');

                    this.pick($color, obj, h, t);
                },
                stop: (h) => {
                    this.render();

                    $color?.removeClass('dragging');
                },
                show: function (h) {
                    setting('controls') ? null : $bar.addClass('fixed');
                },
                hide: function (h) {
                    setting('controls') ? null : $bar.removeClass('fixed');
                },
            });

            $picker.spectrum('toggle');

            position(obj);

            return this;
        }

        PaletteScheme.prototype.pick = function (col, p, h, t) {
            let dispatch = {
                single: (function (_this) {
                    return function () {
                        const m = col.index();

                        _this.col[m] = h;

                        return col.css('background-color', h);
                    };
                })(this),
                sequence: (function (_this) {
                    return function () {
                        _this._base = h;
                        _this.colors().mock().preview(p);
                    };
                })(this),
                gradient: (function (_this) {
                    return function () {
                        const m = p.attr('gradient-index');

                        _this[m === '0' ? '_base' : '_base_end'] = h;

                        _this.colors().mock().preview(p, h);
                    };
                })(this)
            };

            dispatch[t]();

            return this;
        }

        extract = function (obj) {
            if (typeof obj !== 'object') {
                throw "obj is not an object";
            }

            return obj.map(function () {
                return chroma($(this).css('background-color')).hex();
            }).get();
        }

        nohash = function (h) {
            if (typeof h !== 'string') {
                throw "hex is not a string";
            }

            return h.substring(1);
        }

        download = function (p) {
            return new Promise(resolve => {
                p.forEach(c => {
                    const $color = $('<div class="color-static"></div>').css('background-color', c);
                    $tcol.append($color);
                });

                resolve();
            });
        }

        display = function (canvas) {
            const $link = $('<a>');

            $link.attr('href', canvas.toDataURL('image/png'))
                .attr('download', 'palette.png');

            $tpng.append($link);
            $link[0].click();
            $link.remove();
        }

        setting = function (k) {
            let settings = JSON.parse(localStorage.getItem('settings')) || {};

            return settings[k];
        }

        apply = function (settings) {
            let dispatch = {
                controls: function () {
                    $bar.toggleClass('fixed');
                },
                isolate: function () {
                    $pb.toggleClass('isolate');
                },
                orientation: function () {
                    $pb.toggleClass('flex-column');
                },
                info: function () {
                    $pb.toggleClass('info-hidden');
                },
                focus: function () {
                    $fc.toggleClass('focus-mode');

                    if (!document.fullscreenElement) {
                        $fc[0].requestFullscreen().catch(err => {
                            alert(`Error attempting to enable full-screen mode: ${err.message}`);
                        });
                    } else {
                        document.exitFullscreen();
                        $fc.toggleClass('focus-mode');
                    }
                }
            };

            if (typeof settings === 'object') {
                $.each(settings, function (setting, val) {
                    if (val) {
                        dispatch[setting]();
                        $('[data-settings="' + setting + '"]').attr('checked', true);
                    }
                });
            } else {
                dispatch[settings]();
            }
        }

        sidebar = function (obj) {

            let isActive = obj.hasClass('active'),
                tab = obj.data('tab');

            if (tab) {
                if (isActive) {
                    $sb.toggleClass('opened');
                    $bar.toggleClass('offset');
                } else {
                    $sb.addClass('opened');
                    $bar.addClass('offset');

                    $toggle.not(this).removeClass('active');

                    new bootstrap.Tab($('a[data-bs-target="#' + tab + '-tab"]')).show();
                }
            } else {
                $sb.toggleClass('opened');
                $bar.toggleClass('offset');
            }

            let isOpen = $sb.hasClass('opened');

            $mpt.toggleClass('rotate-90', isOpen);

            $toggle.removeClass('active');
            obj.toggleClass('active', isOpen);
        }

        position = function (element) {
            const pickerBox = $('.color-inspector-box');
            const clickedWidth = element.outerWidth();
            const documentHeight = $(document).height();
            const colorBandWidth = $('.color').eq(0).outerWidth();
            const colorBandHeight = $('.color').eq(0).outerHeight();
            const offsetX = Math.max(20, Math.min(element.offset().left + (clickedWidth / 2) - (pickerBox.outerWidth() / 2), $(window).width() - pickerBox.outerWidth() - 20));
            const evOffsetY = $('.stage-box').outerHeight() - (documentHeight - element.offset().top + pickerBox.outerHeight()) - 15;

            let offsetProperties = { left: offsetX };

            if (evOffsetY < 0) {
                offsetProperties.top = 150;
                offsetProperties.bottom = 'auto';
            } else {
                if (colorBandWidth < colorBandHeight) {
                    offsetProperties.bottom = (documentHeight - $('.code').offset().top) + 10;
                    offsetProperties.top = 'auto';
                } else {
                    offsetProperties.bottom = (documentHeight - element.offset().top) + 10;
                    offsetProperties.top = 'auto';
                }
            }

            pickerBox.css(offsetProperties);
        }

        new PaletteScheme;

    })();

    function item(m) {
        return $('<div class="color">' +
            '<div class="inner-panel">' +
            '</div>' +
            '<div class="controls">' +
            '<div class="delete">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>' +
            '</div>' +
            '<div class="panel" data-bs-toggle="tooltip" data-bs-placement="top" title="Open scale">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="19" height="15.667" stroke-width="0.3" stroke="currentColor" fill="currentColor" viewBox="0 0 20 16.667"><g transform="translate(-1377 -490)"><path d="M3.345.228a.78.78,0,0,1,1.1,1.1L1.882,3.9,4.449,6.461a.78.78,0,1,1-1.1,1.1L.229,4.448a.779.779,0,0,1,0-1.1Z" transform="translate(1389.207 500.672) rotate(-90)"/><path d="M2,3.833A.833.833,0,0,1,2.833,3H21.167a.833.833,0,1,1,0,1.667H2.833A.833.833,0,0,1,2,3.833m0,15A.833.833,0,0,1,2.833,18H21.167a.833.833,0,1,1,0,1.667H2.833A.833.833,0,0,1,2,18.833" transform="translate(1375 487)"/><path d="M2,6.779A.73.73,0,0,1,2.668,6h8.014a.73.73,0,0,1,.668.779.73.73,0,0,1-.668.779H2.668A.73.73,0,0,1,2,6.779m0,4.675a.73.73,0,0,1,.668-.779h8.014a.788.788,0,0,1,0,1.558H2.668A.73.73,0,0,1,2,11.454" transform="translate(1375 489.217)"/></g></svg>' +
            '</div>' +
            '<div class="contrast" data-bs-toggle="tooltip" data-bs-placement="top" title="Contrast checker">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"><g transform="translate(-1085 -360)"><g transform="translate(1085 360)" fill="none"><path d="M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z" stroke="none"/><path d="M 10 2 C 5.588789939880371 2 2 5.588789939880371 2 10 C 2 14.41121006011963 5.588789939880371 18 10 18 C 14.41121006011963 18 18 14.41121006011963 18 10 C 18 5.588789939880371 14.41121006011963 2 10 2 M 10 0 C 15.52285003662109 0 20 4.477149963378906 20 10 C 20 15.52285003662109 15.52285003662109 20 10 20 C 4.477149963378906 20 0 15.52285003662109 0 10 C 0 4.477149963378906 4.477149963378906 0 10 0 Z" stroke="none" fill="currentColor"/></g><path d="M10,7a10,10,0,1,1,0,20Z" transform="translate(1105 387) rotate(180)" fill="currentColor"/></g></svg>' +
            '</div>' +
            '<div class="info" data-bs-toggle="tooltip" data-bs-placement="top" title="Open color">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-droplet-half" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M7.21.8C7.69.295 8 0 8 0c.109.363.234.708.371 1.038.812 1.946 2.073 3.35 3.197 4.6C12.878 7.096 14 8.345 14 10a6 6 0 0 1-12 0C2 6.668 5.58 2.517 7.21.8zm.413 1.021A31.25 31.25 0 0 0 5.794 3.99c-.726.95-1.436 2.008-1.96 3.07C3.304 8.133 3 9.138 3 10c0 0 2.5 1.5 5 .5s5-.5 5-.5c0-1.201-.796-2.157-2.181-3.7l-.03-.032C9.75 5.11 8.5 3.72 7.623 1.82z"/><path fill-rule="evenodd" d="M4.553 7.776c.82-1.641 1.717-2.753 2.093-3.13l.708.708c-.29.29-1.128 1.311-1.907 2.87z"/></svg>' +
            '</div>' +
            '<div class="mono" data-bs-toggle="tooltip" data-bs-placement="top" title="Monochrome from this">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 22 18"><g transform="translate(-860 -326)"><g transform="translate(859 323)"><path d="M2,8V6A2,2,0,0,1,4,4H20a2,2,0,0,1,2,2V18a2,2,0,0,1-2,2H14" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g><path d="M.33-4.364H2.959l2.23,5.438h.1l2.23-5.438h2.629V4.419H8.084V-.976H8.011L5.9,4.363H4.58L2.47-1.006H2.4V4.419H.33Z" transform="translate(859.795 338.364)" fill="currentColor"/></g></svg>' +
            '</div>' +
            '<div class="drag" data-bs-toggle="tooltip" data-bs-placement="top" title="Move">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="13" viewBox="0 0 21.456 13.899"><g transform="translate(-1258.272 -527.05)"><g transform="translate(1273 517.029) rotate(45)"><path d="M15,3h6V9" transform="translate(-5.657 5.657)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><path d="M9,21H3V15" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><line x1="7" y2="7" transform="translate(8.343 8.657)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/><line y1="7" x2="7" transform="translate(3 14)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></g></svg>' +
            '</div>' +
            '<div class="copy" data-bs-toggle="tooltip" data-bs-placement="top" title="Copy Hex">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-clipboard"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>' +
            '</div>' +
            '<div class="lock" data-bs-toggle="tooltip" data-bs-placement="top" title="Lock color">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-unlock lock-open"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path></svg>' +
            '</div>' +
            '</div>' +
            '<div class="color-info text-center">' +
            '<div class="code picker" trigger-type="single">######</div>' +
            '<div class="name medium">######</div>' +
            '</div>' +
            '</div>'
        );
    }

    function sample(m) {
        return $('<div class="color-sample" data-color="">' +
            '</div>'
        );
    }

    function shelf(m) {
        return $('<div class="shelf d-flex justify-content-center align-items-center">' +
            '<div class="shelf-code small">' +
            '</div>' +
            '</div>'
        );
    }

    function label(m) {
        return $('<div class="d-flex justify-content-between align-items-center mb-3">' +
            '<div class="small mt-1">My awesome palette</div>' +
            '</div>'
        );
    }

}).call(this);